/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  LinkSkillRequestBody,
  LinkSkillRequestBody$Outbound,
  LinkSkillRequestBody$outboundSchema,
} from "../components/linkskillrequestbody.js";

export type LinkSkillSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type LinkSkillSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type LinkSkillSecurity = {
  option1?: LinkSkillSecurityOption1 | undefined;
  option2?: LinkSkillSecurityOption2 | undefined;
};

export type LinkSkillRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  linkSkillRequestBody: LinkSkillRequestBody;
};

/** @internal */
export type LinkSkillSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const LinkSkillSecurityOption1$outboundSchema: z.ZodMiniType<
  LinkSkillSecurityOption1$Outbound,
  LinkSkillSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function linkSkillSecurityOption1ToJSON(
  linkSkillSecurityOption1: LinkSkillSecurityOption1,
): string {
  return JSON.stringify(
    LinkSkillSecurityOption1$outboundSchema.parse(linkSkillSecurityOption1),
  );
}

/** @internal */
export type LinkSkillSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const LinkSkillSecurityOption2$outboundSchema: z.ZodMiniType<
  LinkSkillSecurityOption2$Outbound,
  LinkSkillSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function linkSkillSecurityOption2ToJSON(
  linkSkillSecurityOption2: LinkSkillSecurityOption2,
): string {
  return JSON.stringify(
    LinkSkillSecurityOption2$outboundSchema.parse(linkSkillSecurityOption2),
  );
}

/** @internal */
export type LinkSkillSecurity$Outbound = {
  Option1?: LinkSkillSecurityOption1$Outbound | undefined;
  Option2?: LinkSkillSecurityOption2$Outbound | undefined;
};

/** @internal */
export const LinkSkillSecurity$outboundSchema: z.ZodMiniType<
  LinkSkillSecurity$Outbound,
  LinkSkillSecurity
> = z.pipe(
  z.object({
    option1: z.optional(z.lazy(() => LinkSkillSecurityOption1$outboundSchema)),
    option2: z.optional(z.lazy(() => LinkSkillSecurityOption2$outboundSchema)),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function linkSkillSecurityToJSON(
  linkSkillSecurity: LinkSkillSecurity,
): string {
  return JSON.stringify(
    LinkSkillSecurity$outboundSchema.parse(linkSkillSecurity),
  );
}

/** @internal */
export type LinkSkillRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  LinkSkillRequestBody: LinkSkillRequestBody$Outbound;
};

/** @internal */
export const LinkSkillRequest$outboundSchema: z.ZodMiniType<
  LinkSkillRequest$Outbound,
  LinkSkillRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    linkSkillRequestBody: LinkSkillRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      linkSkillRequestBody: "LinkSkillRequestBody",
    });
  }),
);

export function linkSkillRequestToJSON(
  linkSkillRequest: LinkSkillRequest,
): string {
  return JSON.stringify(
    LinkSkillRequest$outboundSchema.parse(linkSkillRequest),
  );
}
